import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter004() {
  return <KbChapterPage slug="chapter-004" />;
}

(Chapter004 as unknown as { path: string }).path = "/theory-album/004";
